export default __webpack_public_path__ + "static/media/promoted.e48eca22.png";